import { render, staticRenderFns } from "./SelectFileDialog.vue?vue&type=template&id=040a2a95"
import script from "./SelectFileDialog.vue?vue&type=script&lang=js"
export * from "./SelectFileDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectFileDialog.vue?vue&type=style&index=0&id=040a2a95&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports